import { Injectable } from '@angular/core';
import { RequestsService } from '../requests.service';
import { ConfigService, JSONRPC } from '../../../_constants/config/config.service';
import { catchError, map, Observable } from 'rxjs';
import { HttpsRequestBody, XAPI_METHODS, XAPI_METHODS_NAMES, XAPIS } from '../../../../models/Core.model';
import { User } from '../../../../../_pages/admin/models/Admin.model';
import { REQUEST_STATUSES } from '../../../_constants/values/values.service';


@Injectable({
    providedIn: 'root'
})

export class ApiUsersService {

    private usersObject: any = {};

    constructor(
        private readonly requestsService: RequestsService,
        private readonly configService: ConfigService
    ) { }

    public listInfo(): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.getInfo]
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.result) {
                    return resp.result;
                }
                throw resp;
            }),
            catchError((error: any) => {
                throw error;
            })
        );
    }

    public list(): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.list]
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.result) {
                    return resp.result;
                }
                throw resp;
            }),
            catchError((error: any) => {
                throw error;
            })
        );
    }

    public listTypes(): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.listUsersTypes]
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.result) {
                    return resp.result;
                }
                throw resp;
            }),
            catchError((error: any) => {
                throw error;
            })
        );
    }

    public getUser(userId: number): any {
        return this.usersObject[userId];
    }

    public createUser(user: User): Observable<User> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.create],
            params: user
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.status === REQUEST_STATUSES.success) {
                    if (resp?.result) {
                        return resp.result;
                    }
                    throw resp;
                }
                throw resp;
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    public updateUser(user: User): Observable<User> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.update],
            params: user
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.status === REQUEST_STATUSES.success) {
                    return resp;
                }
                throw resp;
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    public deleteUser(userId: number | string): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.delete],
            params: {
                user_id: userId ?? ''
            }
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.status === REQUEST_STATUSES.success) {
                    return resp;
                }
                throw resp;
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    public changePassword(data: any): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.changePassword],
            params: {
                token: data.token,
                newPassword: data.password
            }
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.status === REQUEST_STATUSES.success) {
                    return resp;
                }
                throw resp;
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    public listRoles(): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.listRoles]
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.result) {
                    return resp.result;
                }
                throw resp;
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    public regenerateToken(userEmail: string): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.regenerateToken],
            params: {
                email: userEmail
            }
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.status === REQUEST_STATUSES.success) {
                    return resp;
                }
                throw resp;
            }),
            catchError((error) => {
                throw error;
            })
        );
    }

    public getInfo(): Observable<any> {
        const _body: HttpsRequestBody = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.users][XAPI_METHODS_NAMES.getInfo]
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.users, _body).pipe(
            map((resp: any) => {
                if (resp?.status === REQUEST_STATUSES.success) {
                    return resp.result;
                }
                throw resp;
            }),
            catchError((error: any) => {
                throw error;
            })
        );
    }
}
